import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.jsx';
import DemoApp from './DemoApp.jsx';
import MapPage from './MapPage.jsx';
import TestMap from './TestMap.jsx';
import SparkMap from './SparkMap.jsx';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/demo" element={<DemoApp />} />
        <Route path="/map" element={<SparkMap />} />
        <Route path="/old-map" element={<MapPage />} />
        <Route path="/test-map" element={<TestMap />} />
      </Routes>
    </BrowserRouter>
  );
}
